const VOLUME_BOT_YOUTUBE_VIDEO_ID = "mT4cs0q1f_w";

const VOLUME_BOT_VIDEO_TITLE =
  "Best Solana Volume Bot | Solana Market Maker | IDX AutoBot";

/** Volume bot landing pages — inline YouTube walkthrough. */
export const VOLUME_BOT_YOUTUBE_VIDEO = {
  embedUrl: `https://www.youtube-nocookie.com/embed/${VOLUME_BOT_YOUTUBE_VIDEO_ID}?si=nA6bbAUK6o0Bl8HI`,
  title: VOLUME_BOT_VIDEO_TITLE,
  iframeTitle: "IDX AutoBot Demo Video",
};

/** Volume bot — demo / SEO video metadata (YouTube). */
export const VOLUME_BOT_DEMO_VIDEO = {
  url: `https://www.youtube.com/watch?v=${VOLUME_BOT_YOUTUBE_VIDEO_ID}`,
  posterUrl: `/video-posters/volume-bot-${VOLUME_BOT_YOUTUBE_VIDEO_ID}.jpg`,
  title: VOLUME_BOT_VIDEO_TITLE,
  description:
    "See how IDX AutoBot volume bot works: configure engines, fund your bot, and boost SPL token volume and DexScreener visibility on Pump.fun, Raydium, Orca, and Meteora.",
  uploadDate: "2025-06-01",
};
